import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Typography,
  Box,
  ListItemIcon,
} from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import { useSessao } from "../../redux/sessao/sessaoHooks";

type Props = {
  ancora: HTMLElement | null;
  setAncora: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  menuIsOpen: boolean;
  setMenuIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const MenuUsuario: React.FC<Props> = (props) => {
  const { ancora, setAncora, menuIsOpen, setMenuIsOpen } = props;
  const [sessao, , logout] = useSessao();

  return (
    <Box>
      <Menu
        id="user-menu"
        anchorEl={ancora}
        open={menuIsOpen}
        onClose={() => setMenuIsOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          elevation: 4,
          sx: {
            minWidth: 220,
            borderRadius: 2,
            padding: 1,
          },
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="subtitle1" fontWeight={600}>
            {sessao.usuario?.nome}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {sessao.usuario?.perfil.descricao}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {sessao.usuario?.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Sair
        </MenuItem>
      </Menu>

      <IconButton
        color="inherit"
        onClick={() => setMenuIsOpen(true)}
        ref={(ref) => {
          if (ref !== null && ancora === null) setAncora(ref);
        }}
      >
        <Avatar sx={{ bgcolor: "#FF5252", width: 32, height: 32 }}>
          {sessao.usuario?.nome.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>
    </Box>
  );
};

export default MenuUsuario;
